import React from 'react';
import PropTypes from 'prop-types';
import {
  Alert,
  FormGroup,
  FormControl,
} from 'react-bootstrap';
import { withTranslation } from 'react-i18next';

 class SendDOEmailBulk extends React.Component {
  static propTypes = {
    defaultRecipient: PropTypes.string,
    updateEmail: PropTypes.func,
    shipment: PropTypes.any,
    updates: PropTypes.any,
  }

  constructor(props) {
    super(props);
    this.state = this.getInitialState();
  }

  getInitialState() {
    return {
      error: null,
      to: this.props.defaultRecipient,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    try {
      let nextEmail = nextProps.updates[nextProps.shipment._id];
      let thisEmail = this.props.updates[nextProps.shipment._id];
      if (nextEmail && nextEmail.meta) {
        nextEmail = nextEmail.meta.email;
        if (thisEmail && thisEmail.meta) {
          thisEmail = thisEmail.meta.email;
          if (thisEmail !== nextEmail) {
            this.setState({ to: nextEmail });
          }
        }
      }
    } catch (e) {
      console.log('didnt have a meta');
    }
  }

  componentWillUnmount() {
    this.setState(this.getInitialState());
  }

  addRecipients(e) {
    const {
      shipment: {
        _id: shipmentId,
      },
    } = this.props;
    const to = e.target.value.trim();
    this.props.updateEmail({ to, shipmentId });
    this.setState({ to });
  }

  renderError() {
    if (!this.state.error) {
      return '';
    }
    return (
      <Alert bsStyle="warning">{this.state.error}</Alert>
    );
  }

  render() {
    const { t } = this.props;
    return (
      <div>
        {this.renderError()}
        <div>
          <FormGroup>
            <FormControl
              placeholder={this.props.t('COMMA_SEPARATED_EMAILS')}
              onChange={(e) => this.addRecipients(e)}
              type="text"
              value={this.state.to}
            />
          </FormGroup>
        </div>
      </div>
    );
  }
}
export default withTranslation()(SendDOEmailBulk)
